import DialogButton from './DialogButton.view';

export default DialogButton;
